import * as React from 'react';
import { format, addMonths, subMonths } from 'date-fns';
import Typography from '@mui/material/Typography';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

type Props = {
  selectedMonth: Date;
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedMonth: (month: Date | null) => void;
  hideButtons?: boolean;
};

export default function CalendarNav({
  selectedMonth,
  setLoading,
  setSelectedMonth,
  hideButtons,
}: Props) {
  const prevMonth = React.useCallback(() => {
    setSelectedMonth(subMonths(selectedMonth, 1));
    setLoading?.(true);
  }, [selectedMonth, setSelectedMonth, setLoading]);

  const nextMonth = React.useCallback(() => {
    setSelectedMonth(addMonths(selectedMonth, 1));
    setLoading?.(true);
  }, [selectedMonth, setSelectedMonth, setLoading]);

  const monthFormat = 'MMMM yyyy';

  return (
    <div className="calendar-header">
      <div className="calendar-header-text">
        <Typography variant="body1">
          {format(selectedMonth, monthFormat)}
        </Typography>
      </div>
      {!hideButtons && (
        <div className="calendar-toggles">
          <ArrowBackIosIcon onClick={prevMonth} id="prev-month" />
          <ArrowForwardIosIcon
            onClick={nextMonth}
            color="primary"
            id="next-month"
          />
        </div>
      )}
    </div>
  );
}
